import React from 'react'
import Dashboard from 'containers/Dashboard'

export default function DashboardPage() {
  return <Dashboard />
}
